import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { MEDIA_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const MEDIA_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: MEDIA_SEGMENT_KEY,
});
